import React from 'react'

import styled from 'styled-components'

import InfoIcon from 'src/Assets/Svg/common/info.svg?react'
import { filterAndSortArtists } from 'src/Constants/functions'
import { SpotifyArtist } from 'src/Redux/spotifyArtistsApi'
import { LabelForArtist } from 'src/Components/LabelForArtist'
import { renderLanguageOrGenreName } from 'src/Components/GenresList/helpers'

type Props = {
  artists?: SpotifyArtist[]
  searchValue: string
  onClickArtist: (artist: SpotifyArtist) => void
  selectedArtists?: SpotifyArtist[]
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`
const Title = styled.h3`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  width: 100%;
  margin: 0;
`
const List = styled.ul`
  display: flex;
  align-items: center;
  align-content: center;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
  padding: 0px;
  margin: 0px;
`
const NoResults = styled.div`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`
const NoResultsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`

export const AdSearchArtistsList: React.FC<Props> = ({
  artists,
  searchValue,
  onClickArtist,
  selectedArtists,
}) => {
  const filtered =
    artists && filterAndSortArtists(artists, String(searchValue || ''))

  if (!filtered || filtered.length === 0) {
    return (
      <NoResultsContainer>
        <InfoIcon width={16} height={16} />
        <NoResults>No search results</NoResults>
      </NoResultsContainer>
    )
  }

  return (
    <Container>
      <Title>Search results</Title>
      <List>
        {filtered.map((artist) => (
          <LabelForArtist
            key={artist.spotifyId}
            title={renderLanguageOrGenreName(artist.name, searchValue)}
            imgUrl={artist.photoUrl}
            hasCross={selectedArtists?.some((a) => a === artist)}
            onClick={() => onClickArtist(artist)}
          />
        ))}
      </List>
    </Container>
  )
}
